export default __webpack_public_path__ + "static/media/VIPL-Financials-2021.66def5b4.pdf";